module.exports = __webpack_public_path__ + "img/2.e5308b4c.jpg";